'use strict';
const ensureElementIfNeeded = require('./util/ensure-element-if-needed'),
	updateNodeDecorations = require('./update-node-decorations'),
	updateNodeText  = require('./core/update-node-text'),
	updateNodeBubble  = require('./core/update-node-bubble'),
	updateNodeIcon = require('./core/update-node-icon');
module.exports = function updateNodeContent(nodeDOM, nodeContent, nodeView) {
	const textDOM = ensureElementIfNeeded(nodeDOM, 'span', '[data-mapjs-role=title]', true, {'data-mapjs-role': 'title'});
	updateNodeDecorations(nodeView, nodeDOM);
	updateNodeText(nodeView, textDOM);
	updateNodeBubble(nodeView, nodeContent, nodeDOM);
	updateNodeIcon(nodeView, nodeDOM);
	nodeDOM.setAttribute('class', ['mapjs-node'].concat(nodeView.effectiveStyles).join(' '));
};

